import React, { PropTypes, Component } from 'react';
import * as SvgIcons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import {
  Styles,
  IconButton,
  RaisedButton,
  TextField,
  Paper,
  LinearProgress
} from 'material-ui';
import DropDown from 'components/Material/DropDown';
import Embed from 'components/Page/Module/Embed';
import VideoPlayer from 'components/Widgets/VideoPlayer';
import { FlexBox } from 'components';
import { PageLayoutActions, CourseActions } from 'actions';
import dropZoneStyles from 'components/Page/Module/Styles';
import FileSelectorDialog from 'components/Widgets/FileSelectorDialog';
import DropZone from 'components/DropZone';
import { Media } from 'Util';
import Config from 'Config';
import SuperAgent from 'superagent';
import SoundCloud from 'services/SoundCloud';
import { FormattedMessage } from 'react-intl';
import CircularProgress from 'components/Material/CircularProgress';
import * as Icons from 'components/Material/SvgIcons';
import { taskTypes } from 'Constants';
import shallowEquals from 'shallow-equals';
import { Units } from 'Css';
import Message from 'services/Message';
import { translate as _l } from 'oxygen-i18n';

const { Spacing } = Styles;

const styles = {
  root: {
    border: 'solid 1px #EEE',
    backgroundColor: Colors.Colors.fullWhite
  },
  value: {
    position: 'relative',
    paddingLeft: Spacing.iconSize * 2 + Spacing.desktopGutterMini * 2,
    paddingRight: Spacing.iconSize * 2 + Spacing.desktopGutterMini * 2
  },
  check: {
    position: 'absolute',
    left: Spacing.desktopGutterMini,
    top: 0,
    bottom: 0,
    lineHeight: '48px'
  },
  icon: {
    cursor: 'pointer',
    verticalAlign: 'middle'
  },
  removeButton: {
    position: 'absolute',
    right: Spacing.desktopGutterMini,
    top: 0,
    bottom: 0,
    lineHeight: '48px'
  }
};

const css = oxygenCss({
  toggleWrapper: {
    padding: `${Units.base}px ${Units.base * 3}px`
  },
  videoDownload: {
    padding: Units.base
  },
  downloadLink: {
    margin: `0 ${Units.base}px`
  }
});

addTranslations({
  ['en-US']: {
    'Choose media': 'Choose media'
  },
  ['sv-SE']: {
    'Choose media': 'Välj media'
  }
});

const supportedExtensions = ['mp4', 'm4a', 'png', 'jpg', 'jpeg', 'webp'];

export default class TaskCreator extends Component {
  static displayName = 'TaskCreator';

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  constructor(props, context) {
    super(props, context);
    this.counter = 1;
    this.menuItems = [
      { payload: 1, text: this.context.getIntlMessage('tasks.singleChoice') },
      { payload: 2, text: this.context.getIntlMessage('tasks.multipleChoice') },
      { payload: 4, text: this.context.getIntlMessage('tasks.openEnded') }
    ];
    let {
      caption,
      correctResponse,
      captionFiles,
      frontend,
      type,
      file,
      sources,
      content,
      params = {}
    } = this.props;
    const mediaTypes = [
      { payload: 0, text: _l`Choose media` },
      { payload: 1, text: 'Image' },
      { payload: 2, text: 'Video' },
      { payload: 3, text: 'Audio' }
    ];
    let values = caption.items.map((item, index) => {
      if (
        correctResponse &&
        correctResponse.value &&
        correctResponse.value.indexOf(index) > -1
      ) {
        return { correct: true, text: item };
      } else {
        return { correct: false, text: item };
      }
    });
    let external = null;
    try {
      external = JSON.parse(
        (this.props.frontend && this.props.frontend[0]) || null
      );
    } catch (err) {}
    let url;
    let fileId;
    let media;
    let currentFile = file
      ? file
      : external
      ? { ...external, type: 'external' }
      : captionFiles && captionFiles[0];
    if (sources && sources.length && sources.length > 0) {
      url = sources[0].data;
      fileId = params && params.file_id && params.file_id[0];
    } else if (params.fileId) {
      url = params.url;
      fileId = params.fileId;
    } else if (content && content.length && content.length > 0) {
      url = content[0].url;
      fileId = content[0].fileId;
    } else if (currentFile) {
      url = currentFile.url;
      fileId = currentFile.id;
      media = mediaTypes.find(t => {
        if (currentFile && currentFile.type.includes('image')) {
          return (
            t.text.toLowerCase() ===
            currentFile.type.replace(/\/(jpeg|jpg|png|webp)/g, '')
          );
        } else if (currentFile && currentFile.type.includes('video')) {
          return (
            t.text.toLowerCase() === currentFile.type.replace(/\/(mp4)/g, '')
          );
        } else if (currentFile && currentFile.type.includes('audio')) {
          return (
            t.text.toLowerCase() ===
            currentFile.type.replace(/\/(mp4|x-m4a)/g, '')
          );
        } else if (
          currentFile.type === 'external' &&
          t.text.toLowerCase() === 'video'
        ) {
          return true;
        }
        return false;
      });
    }

    this.state = {
      description: caption.main || 'Task has no caption',
      comment: caption.comment || '',
      type: type || 1,
      media: (media && media.payload) || 0,
      values,
      file: currentFile,
      edit: {
        url,
        fileId,
        caption,
        sources: [],
        external: !file ? external : file
      }
    };
  }

  addValue() {
    let text = this.context.getIntlMessage('tasks.emptyChoice');
    const values = [
      ...this.state.values,
      { correct: false, text: text, id: this.counter }
    ];
    this.setState({ values });
    this.counter++;
    this.onChange({
      ...this.state,
      values
    });
  }

  removeValue(index) {
    let values = this.state.values;
    values.splice(index, 1);
    this.setState({ values });
    this.onChange({
      ...this.state,
      values
    });
  }

  componentDidMount() {
    this.autoFocus();
  }

  autoFocus() {
    const { field } = this.refs;
    const inputField = field._getInputNode();
    const value = field.getValue();
    field.focus();
    field.setValue(value);
    inputField.select();
  }

  getPreparedTask() {
    return this.state;
  }

  onChange(task) {
    if (this.props.onChange) {
      this.props.onChange(task);
    }
  }

  onCommentChange = e => {
    if (this._timer) {
      clearTimeout(this._timer);
    }
    const comment = e.target.value;
    this._timer = setTimeout(() => {
      this.setState({ comment });
      this.props.onChange({ ...this.state, comment });
      Message.info(this.context.getIntlMessage('video.changesSaved'));
    }, 1000);
  };

  onDescriptionChange(e) {
    if (this._timer) {
      clearTimeout(this._timer);
    }
    let description = e.target.value;
    this._timer = setTimeout(() => {
      this.setState({ description });
      const external = JSON.parse(
        (this.props.frontend && this.props.frontend[0]) || null
      );
      let raw = description;
      const file = this.props.file
        ? this.props.file
        : external
        ? { ...external, type: 'external' }
        : this.props.captionFiles && this.props.captionFiles[0];
      description = file
        ? `[${file.type === 'external' ? 'frontend' : 'file'}:${
            file.type !== 'external' ? file.id : JSON.stringify(file)
          }]${description}`
        : description;
      this.props.onChange({ ...this.state, description }, raw);
      Message.info(this.context.getIntlMessage('video.changesSaved'));
    }, 1000);
  }

  changeText(index, text) {
    const { values } = this.state;
    if (values[index]) {
      values[index].text = text;
    }
    this.setState({ values });
    const external = JSON.parse(
      (this.props.frontend && this.props.frontend[0]) || null
    );
    const file = this.props.file
      ? this.props.file
      : external
      ? { ...external, type: 'external' }
      : this.props.captionFiles && this.props.captionFiles[0];
    const description = file
      ? `[${file.type === 'external' ? 'frontend' : 'file'}:${
          file.type !== 'external' ? file.id : JSON.stringify(file)
        }]${this.state.description}`
      : this.state.description;
    this.props.onChange(
      { ...this.state, values, description },
      this.state.description
    );
  }

  setCorrect(index, correct = false) {
    const external = JSON.parse(
      (this.props.frontend && this.props.frontend[0]) || null
    );
    const file = this.props.file
      ? this.props.file
      : external
      ? { ...external, type: 'external' }
      : this.props.captionFiles && this.props.captionFiles[0];
    const description = file
      ? `[${file.type === 'external' ? 'frontend' : 'file'}:${
          file.type !== 'external' ? file.id : JSON.stringify(file)
        }]${this.state.description}`
      : this.state.description;
    if (this.state.type === taskTypes.SINGLE_CHOICE) {
      if (this.state.values[index]) {
        let values = this.state.values;
        if (correct) {
          values.forEach(value => {
            value.correct = false;
          });
        }
        values[index] = { text: values[index].text, correct };
        this.setState({ values });
        this.props.onChange(
          { ...this.state, values, description },
          this.state.description
        );
      }
    } else {
      if (this.state.values[index]) {
        let values = this.state.values;
        values[index] = { text: values[index].text, correct };
        this.setState({ values });
        this.props.onChange(
          { ...this.state, values, description },
          this.state.description
        );
      }
    }
  }

  changeMediaType(e, selectedIndex, menuItem) {
    this.setState({ media: menuItem.payload });
  }

  changeType(e, selectedIndex, menuItem) {
    if (this.state.type !== menuItem.payload) {
      let values = this.state.values;
      if (
        this.state.type === taskTypes.MULTI_CHOICE &&
        menuItem.payLoad !== taskTypes.MULTI_CHOICE
      ) {
        let hasValue = false;
        values.forEach(value => {
          if (hasValue && value.correct) {
            value.correct = false;
          } else if (!hasValue && value.correct) {
            hasValue = true;
          }
        });
      }
      this.setState({ type: menuItem.payload, values });
      let external = null;
      try {
        external = JSON.parse(
          (this.props.frontend && this.props.frontend[0]) || null
        );
      } catch (err) {}
      const file = this.props.file
        ? this.props.file
        : external
        ? { ...external, type: 'external' }
        : this.props.captionFiles && this.props.captionFiles[0];
      const description = file
        ? `[${file.type !== 'external' ? 'file' : 'frontend'}:${
            file.type !== 'external' ? file.id : JSON.stringify(file)
          }]${this.state.description}`
        : this.state.description;
      this.props.onChange(
        {
          ...this.state,
          type: menuItem.payload,
          values,
          description
        },
        this.state.description
      );
      this.autoFocus();
    }
  }

  renderValueAdder() {
    const values = this.state.values.map((value, index) => {
      return (
        <Value
          key={index}
          onChange={this.changeText.bind(this, index)}
          onRemove={this.removeValue.bind(this, index)}
          onCheck={this.setCorrect.bind(this, index, !value.correct)}
          type={this.state.type}
          {...value}
        />
      );
    });

    return (
      <div>
        {values}
        <RaisedButton
          backgroundColor={this.props.themeColor}
          labelColor="#FFF"
          fullWidth
          onTouchTap={::this.addValue}
          label={this.context.getIntlMessage('tasks.addChoice')}
        />
      </div>
    );
  }

  selectMedia(file) {
    const sources = supportedExtensions.map(extension => {
      return { url: file.url, type: extension };
    });
    const edit = {
      ...this.state.edit,
      fileId: file.id,
      url: `${file.url}`,
      sources,
      external: null
    };
    this.setState({ edit, fileSelectorOpen: false });
    this.props.setFile({ ...file, type: file.mime });
    this.props.onChange(
      {
        ...this.state,
        description: `[file:${file.id}]${this.state.description}`
      },
      this.state.description
    );
    // PageLayoutActions.setPageModuleFile(this.props.pageRowId, this.props.moduleId, file)
  }

  import() {
    const url = this.refs.import.value.trim();
    if (url === '') {
      Message.info(this.context.getIntlMessage('image.provideImportUrl'));
      return;
    }
    SteelCompass.call('file', 'import', { url, encode: false }, response => {
      if (!response.isError) {
        const edit = {
          ...this.state.edit,
          url: response.data.file.url,
          fileId: response.data.file.id
        };
        this.setState({ edit });
        this.props.setFile({
          ...response.data.file,
          type: response.data.file.url.endsWith('jpg')
            ? 'image/jpg'
            : 'image/png'
        });
        this.props.onChange(
          {
            ...this.state,
            description: `[file:${response.data.file.id}]${
              this.state.description
            }`
          },
          this.state.description
        );
        Message.info(this.context.getIntlMessage('image.imported'));
      } else {
        Message.info(this.context.getIntlMessage('image.importFailed'));
      }
    });
  }

  embed() {
    const url = this.refs.embedUrl.value;
    const edit = {
      ...this.state.edit
    };

    if (url !== '') {
      const provider = Media.getProviderFromUrl(url);
      if (provider) {
        if (provider.provider === 3) {
          SoundCloud.oEmbed(url, response => {
            provider.id = response.html;
            edit.external = provider;
            this.setState({ edit });
            this.props.setFile({ ...provider, type: 'external' });
            this.props.onChange(
              {
                ...this.state,
                description: `[frontend:${JSON.stringify(provider)}]${
                  this.state.description
                }`
              },
              this.state.description
            );
          });
        } else {
          edit.external = provider;
          this.setState({ edit });
          this.props.setFile({ ...provider, type: 'external' });
          this.props.onChange(
            {
              ...this.state,
              description: `[frontend:${JSON.stringify(provider)}]${
                this.state.description
              }`
            },
            this.state.description
          );
        }
      } else {
        this.cannotSave();
      }
    }
  }

  progress(e) {
    this.setState({ progress: e.percent, direction: e.direction });
  }

  pollApiForJobId(fileId) {
    setTimeout(() => {
      const now = new Date();
      this.apiPollerStart = this.apiPollerStart || new Date();
      if (now - this.apiPollerStart < 100000) {
        SteelCompass.call('file', 'getJobId', { fileId: fileId }, response => {
          const data = response.data;
          // Poll encoding progress
          if (data && data.jobId && data.accessKey) {
            this.pollZencForProgress(data.jobId, data.accessKey);
            if (!this.state.pollProgress) {
              this.setState({ progress: 0, pollProgress: true });
            }
          } else {
            // Keep polling for jobId
            this.pollApiForJobId(fileId);
          }
        });
      } else {
        // Reset polling
        this.apiPollerStart = null;
      }
    }, 3500);
  }

  pollZencForProgress(jobId, accessKey) {
    setTimeout(() => {
      const now = new Date();
      this.zencPollerStart = this.zencPollerStart || new Date();
      if (
        now - this.zencPollerStart < 100000 ||
        (this.encodingProgress > 0 && this.encodingProgress < 100)
      ) {
        SuperAgent.get(
          Config.zenCoderRoot +
            'jobs/' +
            jobId +
            '/progress.json?api_key=' +
            accessKey
        )
          .set('Content-Type', 'text/plain')
          .end((err, response) => {
            const data = (response && JSON.parse(response.text)) || {};
            // Data object should contain a state and a progress property if the state is still processing.
            if (data.state === 'processing' && data.progress) {
              this.setState({ progress: data.progress });
              this.pollZencForProgress(jobId, accessKey);
            } else if (data.state === 'finished') {
              // Stop the polling
              const sources = this.state.edit.sources.map(source => {
                return {
                  ...source,
                  url: source.url.replace(
                    /deathstar\.s\.coursio\.com\/files/i,
                    'coursio.s3-eu-west-1.amazonaws.com'
                  )
                };
              });
              this.setState({
                progress: 100,
                pollProgress: false,
                edit: {
                  ...this.state.edit,
                  sources
                }
              });
              Message.info(
                this.context.getIntlMessage('media.encodingComplete')
              );
            } else {
              // Keep polling
              this.pollZencForProgress(jobId, accessKey);
            }
          });
      } else {
        // Reset polling
        this.zencPollerStart = null;
      }
    }, 1000);
  }

  attachVideo(data) {
    if (data.length && data.length > 0) {
      const file = data[0].file;
      const sources = supportedExtensions.map(extension => {
        return { url: file.url, type: extension };
      });
      const edit = {
        ...this.state.edit,
        external: null,
        fileId: file.id,
        sources
      };
      this.setState({ edit });
      this.pollApiForJobId(file.id);
      this.props.setFile({ ...file, type: file.mime || 'video/mp4' });
      this.props.onChange(
        {
          ...this.state,
          description: `[file:${file.id}]${this.state.description}`
        },
        this.state.description
      );
      if (!this.state.pollProgress) {
        this.setState({ progress: 0.45, pollProgress: true });
      }
    }
  }

  attachAudio(data) {
    if (data.length && data.length > 0) {
      const file = data[0].file;
      const sources = supportedExtensions.map(extension => {
        return { url: file.url, type: extension };
      });
      const edit = {
        ...this.state.edit,
        external: null,
        fileId: file.id,
        sources
      };
      this.setState({ edit });
      this.props.setFile({ ...file, type: file.mime || 'audio/mp4' });
      this.props.onChange(
        {
          ...this.state,
          description: `[file:${file.id}]${this.state.description}`
        },
        this.state.description
      );
      this.pollApiForJobId(file.id);
    }
  }

  attachImage(uploadedFiles) {
    if (uploadedFiles.length > 0) {
      const edit = {
        ...this.state.edit,
        fileId: uploadedFiles[0] && uploadedFiles[0].file.id,
        url: uploadedFiles[0] && uploadedFiles[0].file.url
      };
      this.setState({ edit });
      this.props.setFile({
        ...uploadedFiles[0].file,
        type: 'image/jpg'
      });
      this.props.onChange(
        {
          ...this.state,
          description: `[file:${uploadedFiles[0].file.id}]${
            this.state.description
          }`
        },
        this.state.description
      );
      this.pollApiForJobId(uploadedFiles[0].file.id);
    }
  }

  onMediaLibrary() {
    this.setState({ fileSelectorOpen: true });
  }

  onMediaLibraryClose() {
    this.setState({ fileSelectorOpen: false });
  }

  openDownload(event) {
    this.refs.dropZone.open();
    event.stopPropagation();
    event.preventDefault();
  }

  renderEditVideo = () => {
    const { sources, external } = this.state.edit;
    let video;

    // let pollProgress;
    // if (this.state.pollProgress) {
    //   pollProgress = <CircularProgress style={{ height: Spacing.desktopKeylineIncrement / 4 }} progressColor={this.context.muiTheme.rawTheme.palette.primary2Color} progress={this.state.progress} size={2} />;
    // }

    const uploadLink = (
      <a onTouchTap={::this.openDownload}>
        {this.context.getIntlMessage('module.upload')}
      </a>
    );
    const libraryLink = (
      <a onTouchTap={::this.onMediaLibrary}>
        {this.context.getIntlMessage('module.library')}
      </a>
    );
    if (
      this.state.pollProgress ||
      (this.state.progress > 0 && this.state.progress < 100)
    ) {
      video = (
        <div>
          <CircularProgress progress={this.state.progress} size={2} />
          <div>
            {this.state.pollProgress
              ? this.context.getIntlMessage('media.encoding')
              : this.context.getIntlMessage('media.uploading')}
          </div>
        </div>
      );
    } else if (
      (sources && sources.length > 0) ||
      (external && external.provider)
    ) {
      if (external && external.provider) {
        video = <Embed params={external} />;
      } else if (this.state.media === 2) {
        video = <VideoPlayer sources={sources} />;
      }
    } else {
      video = <Icons.AvMovie style={dropZoneStyles.icon} />;
    }

    return (
      <div>
        <div style={dropZoneStyles.moduleContainer}>{video}</div>
        <DropZone
          accept="video/*"
          ref="dropZone"
          style={dropZoneStyles.dropZone}
          lineHeight={Spacing.desktopKeylineIncrement / 2}
          onProgress={::this.progress}
          onSuccess={::this.attachVideo}
        >
          <div style={dropZoneStyles.header}>
            {this.context.getIntlMessage('module.dropVideo')}
          </div>
          <div style={dropZoneStyles.subHeader}>
            <FormattedMessage
              message={this.context.getIntlMessage('module.uploadOrBrowse')}
              upload={uploadLink}
              library={libraryLink}
            />
          </div>
          <div style={dropZoneStyles.subHeader}>
            {this.context.getIntlMessage('module.or')}
          </div>
          <Paper style={dropZoneStyles.import.root}>
            <FlexBox>
              <FlexBox>
                <input
                  ref="embedUrl"
                  style={dropZoneStyles.import.input}
                  type="text"
                  placeholder={this.context.getIntlMessage('video.embed')}
                  onChange={::this.embed}
                />
              </FlexBox>
            </FlexBox>
          </Paper>
        </DropZone>
        <FileSelectorDialog
          type="video"
          open={this.state.fileSelectorOpen}
          onSelect={::this.selectMedia}
          onClose={::this.onMediaLibraryClose}
        />
      </div>
    );
  };

  renderEditAudio() {
    const { sources, external, caption } = this.state.edit;

    const audioSources = sources.map(source => {
      return (
        <source
          src={source.url}
          type={'audio/' + source.type}
          key={source.type}
        />
      );
    });

    let audio;

    let pollProgress;
    if (this.state.pollProgress) {
      pollProgress = (
        <LinearProgress
          style={{ height: Spacing.desktopKeylineIncrement / 4 }}
          mode="indeterminate"
        />
      );
    }

    const uploadLink = (
      <a onTouchTap={::this.openDownload}>
        {this.context.getIntlMessage('module.upload')}
      </a>
    );
    const libraryLink = (
      <a onTouchTap={::this.onMediaLibrary}>
        {this.context.getIntlMessage('module.library')}
      </a>
    );
    if (this.state.progress > 0 && this.state.progress < 100) {
      audio = <CircularProgress progress={this.state.progress} size={2} />;
    } else if (sources.length > 0 || (external && external.provider)) {
      if (external && external.provider) {
        audio = <Embed params={external} />;
      } else if (this.state.media === 3) {
        audio = (
          <audio controls style={styles.audio}>
            {audioSources}
          </audio>
        );
      }
    } else {
      audio = <Icons.AvMovie style={dropZoneStyles.icon} />;
    }

    return (
      <div>
        <div style={dropZoneStyles.moduleContainer}>
          {audio}
          {pollProgress}
        </div>
        <DropZone
          accept="audio/*"
          ref="dropZone"
          style={dropZoneStyles.dropZone}
          lineHeight={Spacing.desktopKeylineIncrement / 2}
          onProgress={::this.progress}
          onSuccess={::this.attachAudio}
        >
          <div style={dropZoneStyles.header}>
            {this.context.getIntlMessage('module.dropAudio')}
          </div>
          <div style={dropZoneStyles.subHeader}>
            <FormattedMessage
              message={this.context.getIntlMessage('module.uploadOrBrowse')}
              upload={uploadLink}
              library={libraryLink}
            />
          </div>
          <div style={dropZoneStyles.subHeader}>
            {this.context.getIntlMessage('module.or')}
          </div>
          <Paper style={dropZoneStyles.import.root}>
            <FlexBox>
              <FlexBox>
                <input
                  ref="embedUrl"
                  style={dropZoneStyles.import.input}
                  type="text"
                  placeholder={this.context.getIntlMessage('audio.embed')}
                  onChange={::this.embed}
                />
              </FlexBox>
            </FlexBox>
          </Paper>
        </DropZone>
        <FileSelectorDialog
          type="audio"
          open={this.state.fileSelectorOpen}
          onSelect={::this.selectMedia}
          onClose={::this.onMediaLibraryClose}
        />
      </div>
    );
  }

  renderEditImage = () => {
    const { edit } = this.state || {};
    let image;

    const uploadLink = (
      <a onTouchTap={::this.openDownload}>
        {this.context.getIntlMessage('module.upload')}
      </a>
    );
    const libraryLink = (
      <a onTouchTap={::this.onMediaLibrary}>
        {this.context.getIntlMessage('module.library')}
      </a>
    );
    if (this.state.progress > 0 && this.state.progress < 100) {
      image = <CircularProgress progress={this.state.progress} size={2} />;
    } else if (edit.url) {
      image = <img src={edit.url} style={{ maxWidth: '100%' }} />;
    } else {
      image = <Icons.ImageImage style={dropZoneStyles.icon} />;
    }
    return (
      <div>
        <DropZone
          ref="dropZone"
          style={dropZoneStyles.dropZone}
          lineHeight={Spacing.desktopKeylineIncrement / 2}
          onProgress={::this.progress}
          onSuccess={::this.attachImage}
        >
          <div style={dropZoneStyles.moduleContainer}>{image}</div>
          <div style={dropZoneStyles.header}>
            {this.context.getIntlMessage('module.dropImage')}
          </div>
          <div style={dropZoneStyles.subHeader}>
            <FormattedMessage
              message={this.context.getIntlMessage('module.uploadOrBrowse')}
              upload={uploadLink}
              library={libraryLink}
            />
          </div>
          <div style={dropZoneStyles.subHeader}>
            {this.context.getIntlMessage('module.youCanImport')}
          </div>
          <Paper style={dropZoneStyles.import.root}>
            <FlexBox>
              <FlexBox>
                <input
                  ref={'import'}
                  style={dropZoneStyles.import.input}
                  type="text"
                  placeholder={this.context.getIntlMessage('importFromUrl')}
                  onChange={::this.import}
                />
              </FlexBox>
            </FlexBox>
          </Paper>
        </DropZone>
        <FileSelectorDialog
          type="image"
          open={this.state.fileSelectorOpen}
          onSelect={::this.selectMedia}
          onClose={::this.onMediaLibraryClose}
        />
      </div>
    );
  };

  render() {
    const { progress, direction, media } = this.state;
    const uploading = direction === 'upload' && progress > 0 && progress < 100;
    let valueAdder;
    const mediaTypes = [
      { payload: 0, text: _l`Choose media` },
      { payload: 1, text: 'Image' },
      { payload: 2, text: 'Video' },
      { payload: 3, text: 'Audio' }
    ];
    const selectedIndex = this.menuItems.findIndex(menuItem => {
      return menuItem.payload === this.state.type;
    });
    const selectedMediaIndex = mediaTypes.findIndex(menuItem => {
      return menuItem.payload === this.state.media;
    });
    if (
      this.state.type === taskTypes.SINGLE_CHOICE ||
      this.state.type === taskTypes.MULTI_CHOICE
    ) {
      valueAdder = this.renderValueAdder();
    }

    let currentMedia = null;
    switch (media) {
      case 1:
        currentMedia = this.renderEditImage();
        break;

      case 2:
        currentMedia = this.renderEditVideo();
        break;

      case 3:
        currentMedia = this.renderEditAudio();
        break;

      default:
        break;
    }
    return (
      <div style={styles.root}>
        <div style={{ padding: Spacing.desktopGutterMini }}>
          <DropDown
            onChange={::this.changeType}
            label={this.context.getIntlMessage('tasks.type')}
            menuItems={
              this.props.isQuiz
                ? this.menuItems.filter(i => i.payload !== 4)
                : this.menuItems
            }
            selectedIndex={selectedIndex}
          />

          <DropDown
            onChange={::this.changeMediaType}
            label="Media"
            menuItems={mediaTypes}
            selectedIndex={selectedMediaIndex}
          />

          {currentMedia}
          <TextField
            ref="field"
            onChange={::this.onDescriptionChange}
            multiLine
            fullWidth
            floatingLabelText={
              this.props.isQuiz
                ? this.context.getIntlMessage('tasks.question_description')
                : this.context.getIntlMessage('tasks.description')
            }
            defaultValue={this.state.description}
          />
          <TextField
            onChange={this.onCommentChange}
            multiLine
            fullWidth
            floatingLabelText={this.context.getIntlMessage(
              'pageModule.quizCommentOnQuestion'
            )}
            defaultValue={this.state.comment}
          />

          {valueAdder}
        </div>
      </div>
    );
  }
}

class Value extends Component {
  onCheck() {
    this.props.onCheck();
  }

  onRemove() {
    this.props.onRemove();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEquals(this.props, nextProps);
  }

  onChange(e) {
    const { value } = e.target;
    const { onChange } = this.props;
    onChange && onChange(value);
  }

  componentDidMount() {
    const { field } = this.refs;
    const inputField = field._getInputNode();
    // const value = field.getValue();
    field.focus();
    // field.setValue(value);
    inputField.select();
  }

  render() {
    let { type, correct, text } = this.props;
    let Icon, color;
    if (type === taskTypes.SINGLE_CHOICE) {
      if (correct) {
        color = Colors.Colors.green[500].material;
        Icon = SvgIcons.ToggleRadioButtonChecked;
      } else {
        color = Colors.Text.Dark.text;
        Icon = SvgIcons.ToggleRadioButtonUnchecked;
      }
    } else if (type === taskTypes.MULTI_CHOICE) {
      if (correct) {
        color = Colors.Colors.green[500].material;
        Icon = SvgIcons.ToggleCheckBox;
      } else {
        color = Colors.Text.Dark.text;
        Icon = SvgIcons.ToggleCheckBoxOutlineBlank;
      }
    }
    let icon = (
      <Icon
        color={color}
        hoverColor={Colors.Colors.green[500].material}
        style={styles.icon}
      />
    );
    return (
      <div style={styles.value}>
        <IconButton style={styles.check} onTouchTap={::this.onCheck}>
          {icon}
        </IconButton>
        <TextField
          ref="field"
          fullWidth
          value={this.props.text}
          onChange={::this.onChange}
        />
        <IconButton style={styles.removeButton} onTouchTap={::this.onRemove}>
          <SvgIcons.ContentClear
            style={styles.icon}
            hoverColor={Colors.Colors.red[800].material}
          />
        </IconButton>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Task/TaskCreator.js